{
  "COMPANIES": {
    "HEADER": "Companies",
    "SORT_BY": {
      "LABEL": "Ordenat per",
      "OPTIONS": {
        "NAME": "Nom",
        "DOMAIN": "Domini",
        "CREATED_AT": "Creat per",
        "LAST_ACTIVITY_AT": "Darrera activitat",
        "CONTACTS_COUNT": "Contacts count"
      }
    },
    "ORDER": {
      "LABEL": "Order",
      "OPTIONS": {
        "ASCENDING": "Ascending",
        "DESCENDING": "Descending"
      }
    },
    "SEARCH_PLACEHOLDER": "Search companies...",
    "LOADING": "Loading companies...",
    "UNNAMED": "Unnamed Company",
    "CONTACTS_COUNT": "{n} contact | {n} contacts",
    "ACTIONS": {
      "CREATE": "Add company"
    },
    "CREATE": {
      "TITLE": "Add company details",
      "ACTIONS": {
        "SAVE": "Add company"
      },
      "MESSAGES": {
        "SUCCESS": "Company created.",
        "ERROR": "Could not create the company."
      }
    },
    "DETAIL": {
      "LOADING": "Loading company details...",
      "EMPTY_STATE": {
        "TITLE": "Company not found",
        "SUBTITLE": "This company may have been removed or is no longer available in this account."
      },
      "SIDEBAR": {
        "TABS": {
          "ATTRIBUTES": "Attributes",
          "CONTACTS": "Contactes",
          "HISTORY": "History",
          "NOTES": "Notes"
        }
      },
      "HISTORY": {
        "EMPTY": "No conversations found for this company's contacts yet."
      },
      "NOTES": {
        "EMPTY": "No notes found for this company's contacts yet."
      },
      "ATTRIBUTES": {
        "SEARCH_PLACEHOLDER": "Cerca atributs...",
        "EMPTY_STATE": "There are no company custom attributes configured yet.",
        "NO_ATTRIBUTES": "No matching attributes found.",
        "UNUSED_ATTRIBUTES": "{count} unused attribute | {count} unused attributes",
        "MESSAGES": {
          "UPDATE_SUCCESS": "Company attribute updated.",
          "UPDATE_ERROR": "Could not update company attribute.",
          "DELETE_SUCCESS": "Company attribute removed.",
          "DELETE_ERROR": "Could not remove company attribute."
        }
      },
      "CONTACTS": {
        "LOADING": "Carregant contactes...",
        "EMPTY": "No contacts are linked to this company yet.",
        "UNNAMED_CONTACT": "Unnamed contact",
        "ACTIONS": {
          "ADD": "Add contact",
          "REMOVE": "Remove contact"
        },
        "DIALOGS": {
          "ADD": {
            "DESCRIPTION": "Search for an existing contact and link it to this company.",
            "SEARCH_PLACEHOLDER": "Search contacts...",
            "INITIAL": "Start typing to search contacts.",
            "EMPTY": "No contacts found.",
            "CONFIRM_TITLE": "Link contact",
            "CONFIRM_DESCRIPTION": "Confirm the company and contact before linking them.",
            "COMPANY_LABEL": "Companyia",
            "CONTACT_LABEL": "Contacte",
            "CURRENT_COMPANY": "Currently linked to {companyName}",
            "ADD": "Link contact",
            "CANCEL": "Cancel·la"
          }
        },
        "MESSAGES": {
          "ADD_SUCCESS": "Contact linked to company.",
          "ADD_ERROR": "Could not link contact to company.",
          "REASSIGN_SUCCESS": "Contact reassigned to company.",
          "REASSIGN_ERROR": "Could not reassign contact to company.",
          "REMOVE_SUCCESS": "Contact removed from company.",
          "REMOVE_ERROR": "Could not remove contact from company."
        }
      },
      "AVATAR": {
        "UPDATING": "Updating company avatar...",
        "UPLOAD_SUCCESS": "Company avatar updated.",
        "UPLOAD_ERROR": "Could not update the company avatar.",
        "DELETE_SUCCESS": "Company avatar removed.",
        "DELETE_ERROR": "Could not remove the company avatar."
      },
      "PROFILE": {
        "TITLE": "Edit company details",
        "CREATED_AT": "Created {date}",
        "LAST_ACTIVE": "Last active {date}",
        "DESCRIPTION_PLACEHOLDER": "Add a short description for this company",
        "ACTIONS": {
          "SAVE": "Update company"
        },
        "MESSAGES": {
          "UPDATE_SUCCESS": "Company updated.",
          "UPDATE_ERROR": "Could not update the company."
        },
        "FIELDS": {
          "NAME": "Nom",
          "DOMAIN": "Domini"
        }
      },
      "DELETE": {
        "SECTION_TITLE": "Danger zone",
        "SECTION_DESCRIPTION": "Delete this company and unlink its contacts. The contacts will remain in the account.",
        "BUTTON": "Delete company",
        "TITLE": "Delete company?",
        "DESCRIPTION": "This will remove the company and unlink all associated contacts. Contacts themselves will be preserved.",
        "DESCRIPTION_WITH_NAME": "This will remove {companyName} and unlink all associated contacts. Contacts themselves will be preserved.",
        "CONFIRM": "Delete company",
        "MESSAGES": {
          "SUCCESS": "Company deleted.",
          "ERROR": "Could not delete the company."
        }
      }
    },
    "EMPTY_STATE": {
      "TITLE": "No companies found"
    }
  },
  "COMPANIES_LAYOUT": {
    "PAGINATION_FOOTER": {
      "SHOWING": "Showing {startItem} – {endItem} of {totalItems} company | Showing {startItem} – {endItem} of {totalItems} companies"
    }
  }
}
